// extracted by mini-css-extract-plugin
module.exports = {"containerSpinner":"Loader_containerSpinner__93kPE"};